<script setup>
import { reactive, computed, defineProps, ref } from 'vue'
import YouTube from 'vue3-youtube'

const props = defineProps(['iframeSrc', 'thumbnailSrc'])

const youtubePlayer = ref(null);

const state = reactive({ showThumbnail: true })

const hasYoutubeVideoSrc = computed(() => {
    return ! _.isEmpty(props.iframeSrc)
})

const hasThumbnailSrc = computed(() => {
    return ! _.isEmpty(props.thumbnailSrc)
})

function handlePlayClick() {
    state.showThumbnail = false
    youtubePlayer.value.playVideo()
}
</script>

<template>
    <div class="vue-youtube-wrapper">
        <template v-if="hasYoutubeVideoSrc">
            <div class="inner">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <div class="video-wrapper">
                            <template v-if="state.showThumbnail === true && hasThumbnailSrc">
                                <img :src="thumbnailSrc">
                            </template>

                            <YouTube :src="iframeSrc" ref="youtubePlayer" class="iframe-wrapper"></YouTube>

                            <button v-if="state.showThumbnail === true && hasThumbnailSrc" class="play-button" @click="handlePlayClick" :class="state.showThumbnail ? '' : 'hide'">
                                Play
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>